import { initializePaddle } from '@paddle/paddle-js';

let paddleLoadPromise = null;
let initializedKey = '';

export function paddleCheckoutItems(items = []) {
  return items
    .filter((item) => item?.priceId)
    .map((item) => ({
      priceId: item.priceId,
      quantity: item.quantity || 1,
    }));
}

export async function loadPaddleSdk({ clientToken, environment, eventCallback, customerId } = {}) {
  if (!clientToken) throw new Error('Missing Paddle client-side token');
  if (!environment) throw new Error('Missing Paddle environment');
  if (!['sandbox', 'live'].includes(environment)) throw new Error('Paddle environment must be sandbox or live');

  const key = `${environment}:${clientToken}:${customerId || ''}`;
  if (eventCallback || !paddleLoadPromise || initializedKey !== key) {
    initializedKey = key;
    paddleLoadPromise = initializePaddle({
      token: clientToken,
      environment: environment === 'live' ? 'production' : 'sandbox',
      eventCallback,
      ...(customerId ? { pwCustomer: { id: customerId } } : {}),
    });
  }

  const Paddle = await paddleLoadPromise;
  if (!Paddle) throw new Error('Paddle checkout did not load');
  return Paddle;
}

export async function previewPaddlePrice({ Paddle, priceId, countryCode } = {}) {
  if (!Paddle) throw new Error('Paddle is not loaded');
  if (!priceId) throw new Error('Missing Paddle price ID');
  const payload = {
    items: [{ priceId, quantity: 1 }],
    ...(countryCode ? { address: { countryCode } } : {}),
  };
  return Paddle.PricePreview(payload);
}

export async function previewPaddleItems({ Paddle, items = [], countryCode } = {}) {
  if (!Paddle) throw new Error('Paddle is not loaded');
  const checkoutItems = paddleCheckoutItems(items);
  if (!checkoutItems.length) throw new Error('Missing Paddle price IDs');
  return Paddle.PricePreview({
    items: checkoutItems,
    ...(countryCode ? { address: { countryCode } } : {}),
  });
}

export function formattedPreviewTotal(preview) {
  const lineItem = preview?.data?.details?.lineItems?.[0] || preview?.data?.details?.line_items?.[0];
  return lineItem?.formattedTotals?.total || lineItem?.formatted_totals?.total || '';
}

export function formattedPreviewGrandTotal(preview) {
  const totals = preview?.data?.details?.totals || preview?.data?.details?.formattedTotals || preview?.data?.details?.formatted_totals;
  return totals?.formattedTotals?.total || totals?.formatted_totals?.total || totals?.total || '';
}
